export default __webpack_public_path__ + "static/media/pic.5777329e.svg";